const ShowInformationTitle = () => {
  return <span className="pl-[5%] text-Subhead">기본 정보</span>;
};

export default ShowInformationTitle;
